const api = {
  LOCALSTORAGE_APP_TOKEN: 'LOCALSTORAGE_APP_TOKEN',
  LOCALSTORAGE_USER_TOKEN: 'REACT_USER_TOKEN_AUTH',

  QUERIES_PAGE_SIZE: 10,
  API: {
    OAUTH: '/oauth/token',
    INTERNAL: {
      INFO: {
        IP: '/internal/ip/{ip}',
      },
      IDENTITY:{
        QUESTIONS: '/users/identity/questions',
        VERIFY: '/users/identity/verify',
        FIND: '/users/find',
      }
    },

    FILES: '/files/upload',
    SETTINGS: '/settings',
    TOKEN: '/users/token',
    LOGIN: '/users/login',
    SOCIAL_LOGIN: '/users/login/social',
    REGISTER: '/users/register',
    FORGOT: '/users/forgot',
    VERIFY: '/users/verify',
    VERIFY_RETRY: '/users/verify/retry',
    USER: '/users/{id}',
    USERS: '/users',
    HASH: '/users/hash/{hash}',
    SOCIAL: '/users/social',


    TRANSACTION: '/transactions/{id}',
    TRANSACTIONS: '/transactions',
    TRANSACTIONS_PAY: '/transactions/mp/pay',
    TRANSACTIONS_PREFERENCE: '/transactions/mp/get_preference',
    TRANSACTIONS_CONFIRM_PAYMENT: '/transactions/mp/confirm',

    BUSINESS: '/businesses/{id}',
    BUSINESSES: '/businesses',
    PRESCRIPTION: '/prescriptions/{id}',
    PRESCRIPTIONS: '/prescriptions',
    MEDICAMENT: '/vademecum/{id}',
    MEDICAMENTS: '/vademecum',
    INSURANCE: '/insurances/{id}',
    INSURANCES: '/insurances',
    ASSOCIATION: '/associations/{id}',
    ASSOCIATIONS: '/associations',

    CALLS: '/calls',
    CALL: '/calls/{id}',

    BOOKING: '/bookings/{id}',
    BOOKINGS: '/bookings',
    AVAILABILITY: '/bookings/{owner}/availability',


    MESSAGES: '/messages',
    MESSAGE: '/messages/{id}',

    NOTIFICATIONS: '/notifications',
    NOTIFICATION: '/notifications/{id}',
    
    LOCATION: '/locations/{id}',
    LOCATIONS: '/locations',

    VIDEO_SESSION: '/video/session',
    VIDEO_TOKEN: '/video/session/{sessionid}/token',
    VIDEO_SESSION_TOKEN: '/video/token',
  },
};
export default api;